module.exports = __webpack_public_path__ + "static/img/wdcs.7bd233a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wdcs.svg
// module id = 55
// module chunks = 40